import React, { useEffect, useState } from "react";
import EmptyListUi from "../../../../components/EmptyListUi";
import {
  Button,
  Stack,
  TextField,
  Paper,
  Card,
  CardHeader,
  IconButton,
  CardContent,
  Typography,
  Box,
  Avatar,
  Divider,
  Chip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useQuery } from "react-query";
import axiosInstance from "../../../../utils/axiosInstance";
import { usersUrl } from "../../../../utils/urls";
import LoadingUI from "../../../../components/LoadingUI";
import { Check, Close, Email, Phone } from "@mui/icons-material";
import PageHeader from "../../../../components/page-layout/PageHeader";
import { deepPurple } from "@mui/material/colors";
import VendorDispalyCard from "../../../../components/pages/stores/VendorDispalyCard";

const VendorStep = ({ formData, setFormData, onBack, nextStep }) => {
  const [search, setSearch] = useState("");
  const searchHandler = (e) => setSearch(e.target.value);
  const [selectedVendor, setSelectedVendor] = useState({});

  useEffect(() => {
    console.log({ formData });
    if (formData.vendor) {
      setSelectedVendor(formData.vendor);
    }
  }, [formData]);

  const { data, isLoading } = useQuery(
    ["vendor-list", search],
    () =>
      axiosInstance.get(`${usersUrl}/list`, { params: { role: "VENDOR", name: search } }),
    {
      onSuccess: (res) => {
        console.log(res.data);
      },
      enabled: !!search,
    }
  );

  const vendorList = data?.data || [];

  const columns = [
    { field: "name", headerName: "Name", flex: 1 },
    {
      field: "phoneNumber",
      headerName: "Phone",
      flex: 1,
    },
    { field: "email", headerName: "Email", flex: 1 },
    {
      field: "choose",
      headerName: "Choose",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        params.row.hasStore?<Chip label="Already has store"/>:
        <Button
          size="small"
          startIcon={params.row.id === selectedVendor.id ? <Check /> : null}
          variant={
            params.row.id === selectedVendor.id ? "contained" : "outlined"
          }
          // onClick={() => setFieldValue("vendorId", params.row.id)}
          onClick={() => {
            setSelectedVendor(params.row);
            setFormData((prev) => ({ ...prev, vendor: params.row }));
          }}
        >
          {params.row.id === selectedVendor.id ? "Choosen" : "Choose"}
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Box>
        <PageHeader
          title={"Vendor Details"}
          lead={
            "Search and select a vendor to associate with this store. You can only proceed after choosing a vendor."
          }
        />
        {selectedVendor && selectedVendor.id && (
          <VendorDispalyCard
            vendor={selectedVendor}
            buttonTitle={<Close/>}
            buttonOnClick={() => {
              setSelectedVendor({});
              setFormData((prev) => ({ ...prev, vendor: null }));
            }}
          />
        )}
        <Stack>
          <TextField
            name="query"
            label="Search vendor for Store"
            fullWidth
            sx={{ mb: 2 }}
            value={search}
            onChange={searchHandler}
            autoFocus
            InputProps={{
              sx: { borderRadius: 2,},
            }}
          />
          {isLoading ? (
            <LoadingUI text="Loading Vendors..." />
          ) : vendorList.length && search ? (
            <Paper sx={{ boxShadow: "none", border: "none" }}>
              <div style={{ height: "52vh", width: "100%", overflow: "auto" }}>
                <DataGrid
                  rows={vendorList.map((v) => ({ ...v, id: v.id }))}
                  columns={columns}
                  pageSize={5}
                  rowsPerPageOptions={[5, 10, 20]}
                  disableSelectionOnClick
                  autoHeight
                />
              </div>
            </Paper>
          ) : (
            !selectedVendor.name && (
              <EmptyListUi
                text={
                  vendorList.length
                    ? "No Vendor Found"
                    : "Search & select Vendor to Create Store"
                }
              />
            )
          )}
        </Stack>
      </Box>

      <Stack gap={2} mt={2} flexDirection={"row"} justifyContent={"flex-end"}>
        <Button
          variant="outlined"
          size="small"
          disabled={!onBack}
          onClick={onBack}
        >
          Back
        </Button>

        <Button
          type="submit"
          variant="contained"
          disabled={!formData.vendor}
          onClick={nextStep}
        >
          Save & Next
        </Button>
      </Stack>
    </div>
  );
};

export default VendorStep;
